import client from "./client";

export async function getPubNubToken(): Promise<string> {
  const res = await client.get<{ result: string }>("/api/user/pubnub/token");
  return res.data.result;
}
